export default __webpack_public_path__ + "static/media/3.cabb1b9b.png";